var _a, _b;
import { __assign } from "tslib";
import * as React from 'react';
import linkifyHtml from 'linkify-html';
import * as moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import MomentEnum from '../../../enums/MomentEnum';
import TimeFormatsEnum from '../../../enums/TimeFormatsEnum';
import ReactResizeDetector from 'react-resize-detector';
import { Event as TPAEvent, Text } from 'wix-ui-tpa';
import Popper from '../UI/Popper/Popper';
import EventContainer from '../EventContainer/EventContainer';
import FillerContainer from '../FillerContainer/FillerContainer';
// import ExpandedEvent from '../ExpandedEvent/ExpandedEvent';
import WeeklyExpandedEvent from '../WeeklyExpandedEvent/WeeklyExpandedEvent';
import * as utils from '../../containers/Calendar/CalendarUtlis/CalendarUtils';
import EventTypes from '../../../enums/EventTypesEnum';
import { st, classes } from './Event.st.css';
import Popups from '../../../enums/PopupsEnum';
import WixStylesContext from '../../../context/wixStylesContext';
import getAccessRoleAndCalendarName from '../../../utils/getAccessRoleAndCalendarName';
import CalendarPropsContext from '../../../context/calendarPropsContext';
import { DEMO_CALENDARS_IDS, EVENT_BACKGROUND_OPACITY, } from '../../../constants';
import { setOpacity } from '../../../utils/colorUtils';
var getInlineStyle = function (eventColor, indicatorWidth, withBackground, withBorder) { return ({
    background: withBackground
        ? setOpacity(EVENT_BACKGROUND_OPACITY, eventColor)
        : '',
    borderLeft: withBorder && setOpacity(EVENT_BACKGROUND_OPACITY, eventColor)
        ? "".concat(indicatorWidth, "px solid ").concat(setOpacity(EVENT_BACKGROUND_OPACITY, eventColor))
        : '',
}); };
var inlineStyles = (_a = {},
    _a[EventTypes.AllDay] = function (eventColor, indicatorWidth) {
        return getInlineStyle(eventColor, indicatorWidth, true, false);
    },
    _a[EventTypes.Filler] = function (eventColor, indicatorWidth) {
        return getInlineStyle(eventColor, indicatorWidth, true, false);
    },
    _a[EventTypes.AllDayMultiDay] = function (eventColor, indicatorWidth) {
        return getInlineStyle(eventColor, indicatorWidth, true, false);
    },
    _a[EventTypes.MultiDay] = function (eventColor, indicatorWidth) {
        return getInlineStyle(eventColor, indicatorWidth, true, false);
    },
    _a[EventTypes.Default] = function (eventColor, indicatorWidth, isAgenda) {
        return getInlineStyle(eventColor, indicatorWidth, false, isAgenda);
    },
    _a[EventTypes.Null] = function (eventColor, indicatorWidth) {
        return getInlineStyle(eventColor, indicatorWidth, false, false);
    },
    _a[EventTypes.ShowMore] = function () { return getInlineStyle('', '', false, false); },
    _a);
var eventContainers = (_b = {},
    _b[EventTypes.Filler] = function (_a) {
        var closeExpanded = _a.closeExpanded, event = _a.event, options = _a.options, handleEventClick = _a.handleEventClick, popper = _a.popper, isInPopper = _a.isInPopper, isMobile = _a.isMobile, isAgenda = _a.isAgenda, isCut = _a.isCut, isWeekend = _a.isWeekend, isToday = _a.isToday;
        return (React.createElement(FillerContainer, __assign({ closeExpanded: closeExpanded, isToday: isToday, isWeekend: isWeekend, isCut: isCut, isAgenda: isAgenda, className: classes.FillerContainerExtension, isMobile: isMobile, isInPopper: isInPopper, popper: popper, handleEventClick: handleEventClick, event: event() }, options)));
    },
    _b[EventTypes.AllDay] = function (_a) {
        var event = _a.event, handleEventClick = _a.handleEventClick, popper = _a.popper, isInPopper = _a.isInPopper, isMobile = _a.isMobile, isAgenda = _a.isAgenda, isCut = _a.isCut;
        return (React.createElement(EventContainer, { isCut: isCut, isAgenda: isAgenda, className: classes.EventContainerExtension, isMobile: isMobile, isInPopper: isInPopper, popper: popper, handleEventClick: handleEventClick, event: event(), isAllDay: true }));
    },
    _b[EventTypes.MultiDay] = function (_a) {
        var event = _a.event, handleEventClick = _a.handleEventClick, popper = _a.popper, isInPopper = _a.isInPopper, isMobile = _a.isMobile, isAgenda = _a.isAgenda, isCut = _a.isCut, isWeekend = _a.isWeekend;
        return (React.createElement(EventContainer, { isWeekend: isWeekend, isCut: isCut, isAgenda: isAgenda, className: classes.EventContainerExtension, isMobile: isMobile, isInPopper: isInPopper, popper: popper, handleEventClick: handleEventClick, event: event(), isMultiDay: true }));
    },
    _b[EventTypes.AllDayMultiDay] = function (_a) {
        var event = _a.event, handleEventClick = _a.handleEventClick, popper = _a.popper;
        return event(handleEventClick, popper);
    },
    _b[EventTypes.Default] = function (_a) {
        var event = _a.event, handleEventClick = _a.handleEventClick, popper = _a.popper, isInPopper = _a.isInPopper, isMobile = _a.isMobile, isAgenda = _a.isAgenda, isCut = _a.isCut;
        return (React.createElement(EventContainer, { isCut: isCut, isAgenda: isAgenda, className: classes.EventContainerExtension, isMobile: isMobile, popper: popper, handleEventClick: handleEventClick, event: event(), isInPopper: isInPopper }));
    },
    _b[EventTypes.Null] = function (_a) {
        var event = _a.event, handleEventClick = _a.handleEventClick, popper = _a.popper, isMobile = _a.isMobile, isAgenda = _a.isAgenda, isCut = _a.isCut;
        return (React.createElement(EventContainer, { isCut: isCut, isAgenda: isAgenda, className: classes.EventContainerExtension, isMobile: isMobile, popper: popper, handleEventClick: handleEventClick, event: event() }));
    },
    _b[EventTypes.ShowMore] = function (_a) {
        var event = _a.event, handleEventClick = _a.handleEventClick, isMobile = _a.isMobile, isAgenda = _a.isAgenda, isCut = _a.isCut;
        return (React.createElement(EventContainer, { isCut: isCut, isAgenda: isAgenda, className: classes.EventContainerExtension, isMobile: isMobile, handleEventClick: handleEventClick, event: event() }));
    },
    _b);
var Event = function (_a) {
    var 
    // timezone = '', // memo dependency - timezone isn't used in the component but does effect the global moment which effect the time display
    _b = _a.duration, 
    // timezone = '', // memo dependency - timezone isn't used in the component but does effect the global moment which effect the time display
    duration = _b === void 0 ? 0 : _b, _c = _a.daysTillWeekend, daysTillWeekend = _c === void 0 ? 0 : _c, _d = _a.popperModifiers, popperModifiers = _d === void 0 ? null : _d, _e = _a.isWeekend, isWeekend = _e === void 0 ? false : _e, _f = _a.isHover, isHover = _f === void 0 ? false : _f, _g = _a.isPrivate, isPrivate = _g === void 0 ? false : _g, _h = _a.toggleEventRender, toggleEventRender = _h === void 0 ? false : _h, _j = _a.isPastShown, isPastShown = _j === void 0 ? false : _j, type = _a.type, _k = _a.isLastFiller, isLastFiller = _k === void 0 ? false : _k, _l = _a.isNextWeekFirstFiller, isNextWeekFirstFiller = _l === void 0 ? false : _l, _m = _a.isFiller, isFiller = _m === void 0 ? false : _m, _o = _a.isTimeShown, isTimeShown = _o === void 0 ? false : _o, _p = _a.isAllDay, isAllDay = _p === void 0 ? false : _p, _q = _a.isMultiDay, isMultiDay = _q === void 0 ? false : _q, _r = _a.isInPopper, isInPopper = _r === void 0 ? false : _r, _s = _a.isDetailsVisible, isDetailsVisible = _s === void 0 ? true : _s, _t = _a.isMobile, isMobile = _t === void 0 ? false : _t, _u = _a.isAgenda, isAgenda = _u === void 0 ? false : _u, _v = _a.isCut, isCut = _v === void 0 ? false : _v, _w = _a.isSelected, isSelected = _w === void 0 ? true : _w, // until wrapper/server stops to send this property in the getEvents, this should be a dependency
    _x = _a.isDetailsVisble, // until wrapper/server stops to send this property in the getEvents, this should be a dependency
    isDetailsVisble = _x === void 0 ? true : _x, // same
    localeToggle = _a.localeToggle, _y = _a.id, id = _y === void 0 ? '' : _y, _z = _a.originEventId, originEventId = _z === void 0 ? '' : _z, _0 = _a.eventColor, eventColor = _0 === void 0 ? '' : _0, _1 = _a.startDate, startDate = _1 === void 0 ? '' : _1, _2 = _a.endDate, endDate = _2 === void 0 ? '' : _2, _3 = _a.title, title = _3 === void 0 ? '' : _3, _4 = _a.summary, summary = _4 === void 0 ? '' : _4, _5 = _a.location, location = _5 === void 0 ? '' : _5, _6 = _a.locationLink, locationLink = _6 === void 0 ? '' : _6, _7 = _a.popperPlacement, popperPlacement = _7 === void 0 ? '' : _7, _8 = _a.recurrence, recurrence = _8 === void 0 ? '' : _8, _9 = _a.timeFormat, timeFormat = _9 === void 0 ? '' : _9, _10 = _a.className, className = _10 === void 0 ? '' : _10, _11 = _a.copyLink, copyLink = _11 === void 0 ? '' : _11, _12 = _a.calendarId, calendarId = _12 === void 0 ? '' : _12, _13 = _a.attachments, attachments = _13 === void 0 ? [] : _13, _14 = _a.popperStyle, popperStyle = _14 === void 0 ? {} : _14, _15 = _a.handleTitleResize, handleTitleResize = _15 === void 0 ? function (width, height) { } : _15, _16 = _a.handleTimeResize, handleTimeResize = _16 === void 0 ? function (width, height) { } : _16, _17 = _a.handleCut, handleCut = _17 === void 0 ? null : _17, _18 = _a.onHover, onHover = _18 === void 0 ? null : _18, _19 = _a.cuttedEventIndex, cuttedEventIndex = _19 === void 0 ? Infinity : _19, _20 = _a.cuttedDate, cuttedDate = _20 === void 0 ? '' : _20, _21 = _a.eventIndex, eventIndex = _21 === void 0 ? 0 : _21, _22 = _a.cellDate, cellDate = _22 === void 0 ? '' : _22, // cellDate is needed because fillers has startDate set to the startDate of the multi day event they belong to
    _23 = _a.orderPosition, // cellDate is needed because fillers has startDate set to the startDate of the multi day event they belong to
    orderPosition = _23 === void 0 ? '' : _23, _24 = _a.openPopup, openPopup = _24 === void 0 ? null : _24, _25 = _a.originType, originType = _25 === void 0 ? '' : _25, _26 = _a.recurringEventId, recurringEventId = _26 === void 0 ? '' : _26, _27 = _a.onEventExpanded, onEventExpanded = _27 === void 0 ? null : _27, _28 = _a.onCopyClick, onCopyClick = _28 === void 0 ? null : _28, _29 = _a.onLocationClick, onLocationClick = _29 === void 0 ? null : _29, _30 = _a.onAttachmentClick, onAttachmentClick = _30 === void 0 ? null : _30, _31 = _a.setFirstEventRef, setFirstEventRef = _31 === void 0 ? null : _31, _32 = _a.weekStarter, weekStarter = _32 === void 0 ? '' : _32, _33 = _a.groupByStartDate, groupByStartDate = _33 === void 0 ? '' : _33, experiments = _a.experiments, privetEventsTitle = _a.privetEventsTitle;
    var indicatorWidth = React.useContext(WixStylesContext).indicatorWidth;
    var _34 = React.useState(null), expanded = _34[0], setExpanded = _34[1];
    var _35 = React.useState(false), isEventEntered = _35[0], setIsEventEntered = _35[1];
    var _36 = React.useState({
        titleWidth: 0,
        eventWidth: 0,
    }), widthState = _36[0], setWidth = _36[1];
    //@ts-ignore
    var eventRef = React.useRef();
    //@ts-ignore
    var eventTimeRef = React.useRef();
    var t = useTranslation()[0];
    React.useEffect(function () {
        if (eventIndex === 0 && setFirstEventRef) {
            //@ts-ignore
            setFirstEventRef(eventRef);
        }
        setWidthState();
        //@ts-ignore
        !isCut && handleCut && handleCut(eventIndex, eventRef, cellDate); // this send the last seen event to the handler, so the ref the handler will use will always be the one closest to the end of the window (the last one shown  ).
    }, [cuttedEventIndex, cuttedDate, isPastShown, toggleEventRender]); // isCut & cuttedEventIndex - will not change for shown event after resize, cuttedEventIndex and cuttedDate will. in order to get the ref of the last shown index cuttedEventIndex is the dependency.
    // isPastShown - we need this dependency so after clicking show past events the last saved ref at the agenda will still be the last event ref shown.
    React.useEffect(function () {
        var handleKeyPress = function (event) {
            if (event.key === 'Enter') {
                setExpanded(null);
            }
        };
        window.addEventListener('keyup', handleKeyPress);
        return function () { return window.removeEventListener('keyup', handleKeyPress); };
    }, []);
    var setWidthState = function () {
        var eventWidth = eventRef.current.getBoundingClientRect().width;
        var beforeWidth = 12;
        var titleWidth = eventWidth - beforeWidth;
        if (isTimeShown &&
            !isInPopper &&
            ((isMultiDay && !isAllDay) || isNextWeekFirstFiller)) {
            var timeWidth = eventTimeRef.current.getBoundingClientRect().width + 3; //padding-right:  3px
            titleWidth -= timeWidth;
            setWidth({ titleWidth: titleWidth, eventWidth: eventWidth });
        }
        else if ((!isInPopper && !isTimeShown && (isMultiDay || isNextWeekFirstFiller)) ||
            (isTimeShown && isMultiDay && isAllDay)) {
            setWidth({ titleWidth: titleWidth, eventWidth: eventWidth });
        }
    };
    var inlineStyle = inlineStyles[type](eventColor, indicatorWidth, isAgenda);
    var colorIndicator = type === EventTypes.Default && !isAgenda ? (React.createElement("div", { className: classes.ColorIndicator, style: { background: "".concat(eventColor) } })) : null;
    var _handleResize = function (_a) {
        var height = _a.height, resizeHandler = _a.resizeHandler;
        var eventBottomMargin = 4; // the li event container bottom-margin
        var eventStyle = window.getComputedStyle(eventRef.current.children[0].children[0].children[0]); // currently TPAEvent has no ref
        var eventTopPadding = Number(eventStyle.getPropertyValue('padding-bottom').replace('px', ''));
        var eventBottomPadding = Number(eventStyle.getPropertyValue('padding-top').replace('px', ''));
        resizeHandler &&
            resizeHandler(0, height + eventBottomMargin + eventTopPadding + eventBottomPadding);
    };
    var titleToDisplay = title; // fix me
    var _37 = React.useContext(CalendarPropsContext), calendarsList = _37.calendarsList, locale = _37.locale;
    var _38 = getAccessRoleAndCalendarName(calendarsList, calendarId), accessRole = _38.accessRole, calendarName = _38.calendarName;
    if (accessRole === 'freeBusyReader') {
        titleToDisplay = t('Google_Calendar_Busy');
    }
    if (isPrivate && accessRole !== 'freeBusyReader') {
        titleToDisplay = t('Google_Calendar_Private');
        if (typeof privetEventsTitle !== 'undefined' &&
            privetEventsTitle.length > 0) {
            titleToDisplay = privetEventsTitle;
        }
    }
    // if (!isDetailsVisible) {
    //   titleToDisplay = t('Google_Calendar_Busy');
    // } else if (isPrivate) {
    //   titleToDisplay = t('Google_Calendar_Private'); // FIXME
    //   if (
    //     typeof privetEventsTitle !== 'undefined' &&
    //     privetEventsTitle.length > 0
    //   ) {
    //     titleToDisplay = privetEventsTitle;
    //   }
    // }
    else if (DEMO_CALENDARS_IDS.includes(calendarId)) {
        titleToDisplay = t(title);
        summary = t(summary);
    }
    else if ((isMobile || isAgenda) && orderPosition) {
        titleToDisplay = "".concat(titleToDisplay, " (").concat(t('Google_Calendar_Day'), " ").concat(orderPosition, ")");
    }
    var timeToDisplay = startDate ? moment(startDate).format(timeFormat) : '';
    var endDateToDisplay = endDate ? moment(endDate).format(timeFormat) : '';
    var timeFormatByLocale = timeFormat === TimeFormatsEnum.tweleveHours
        ? moment.locale() === 'ko'
            ? "".concat(MomentEnum.ampm).concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute)
            : "".concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute).concat(MomentEnum.ampm)
        : "".concat(MomentEnum.fullHour, ":").concat(MomentEnum.fullMinute);
    timeToDisplay = startDate
        ? moment(startDate).format(timeFormatByLocale)
        : '';
    endDateToDisplay = endDate
        ? moment(endDate).format(timeFormatByLocale)
        : '';
    var isLastEventDate = utils.isLastEventDate({
        eventEndDate: endDate,
        date: cellDate,
    });
    if (isMobile || isAgenda) {
        if (isMultiDay && !isAllDay) {
            timeToDisplay = "".concat(timeToDisplay);
        }
        else if (isFiller &&
            originType === EventTypes.MultiDay &&
            isLastEventDate) {
            timeToDisplay = "".concat(t('Google_Calendar_Until'), " ").concat(endDateToDisplay);
        }
        else {
            timeToDisplay = "".concat(timeToDisplay, " - ").concat(endDateToDisplay);
        }
    }
    var titleInlineStyle = null;
    var getTitleWidth = function (daysToSpreadOn, isLastWeek) {
        if (isLastWeek === void 0) { isLastWeek = false; }
        var titleWidth = widthState.titleWidth, eventWidth = widthState.eventWidth;
        var paddingToDrop = isLastWeek ? '19px' : '0px'; // 19 = 12(rightPadding in last filler) + 4(event after) +  3(time rightPadding)
        return {
            width: "calc(".concat(titleWidth, "px + (").concat(daysToSpreadOn, " * ").concat(eventWidth, "px)  - ").concat(paddingToDrop, ")"),
        };
    };
    if (isMultiDay && !isAgenda && !isInPopper && !isMobile) {
        var fillersAmount = duration - 1;
        var isLastWeek = fillersAmount <= daysTillWeekend;
        var multiDaysToSpreadOn = isLastWeek ? fillersAmount : daysTillWeekend;
        //@ts-ignore
        titleInlineStyle =
            multiDaysToSpreadOn === 0
                ? {}
                : getTitleWidth(multiDaysToSpreadOn, isLastWeek);
    }
    if (isNextWeekFirstFiller && !isAgenda && !isInPopper && !isMobile) {
        var fillersAmount = utils.getDiffAsDays(endDate, cellDate);
        var isLastWeek = fillersAmount <= daysTillWeekend;
        var fillerDaysToSpreadOn = isLastWeek ? fillersAmount : daysTillWeekend;
        //@ts-ignore
        titleInlineStyle =
            fillerDaysToSpreadOn === 0
                ? {}
                : getTitleWidth(fillerDaysToSpreadOn, isLastWeek);
    }
    var eventTitle = (React.createElement("div", { style: { display: 'flex' } },
        !isTimeShown && colorIndicator,
        React.createElement("div", { style: titleInlineStyle, className: classes.EventTitle },
            titleToDisplay,
            React.createElement(ReactResizeDetector, { onResize: function (width, height) {
                    return _handleResize({ height: height, resizeHandler: handleTitleResize });
                } }))));
    var eventTime = (React.createElement("div", { ref: eventTimeRef, className: classes.EventTime },
        colorIndicator,
        timeToDisplay,
        React.createElement(ReactResizeDetector, { onResize: function (width, height) {
                return _handleResize({ height: height, resizeHandler: handleTimeResize });
            } })));
    var expandedData = {
        recurrence: recurrence,
        recurringEventId: recurringEventId,
        calendarId: calendarId
    };
    var handleEventClick = function (eventElement, isEnterClicked) {
        if (openPopup) {
            //@ts-ignore
            return openPopup({
                popup: Popups.EVENT,
                expandedEventsProps: expandedEventsProps,
                expandedData: expandedData,
                isCloseFocused: isEnterClicked,
            });
        }
        setIsEventEntered(isEnterClicked);
        setExpanded(expanded || type === EventTypes.ShowMore
            ? null
            : eventElement.currentTarget);
        //@ts-ignore
        // onEventExpanded && onEventExpanded(expandedData); //FIXME
        onEventExpanded && onEventExpanded(expandedData);
    };
    var closeExpanded = function () {
        setExpanded(null);
    };
    var expandedTitle = (React.createElement("div", { className: classes.ExpandedTitleContainer, style: { borderLeft: "2px solid ".concat(setOpacity(1, eventColor)) } },
        React.createElement(Text, { className: classes.ExpandedTitle }, titleToDisplay)));
    var convertToLinkifyHtml = function (summary) {
        var fixedSummary = summary.replace('</stron ', '</strong>');
        var origFixedSummary = fixedSummary;
        try {
            fixedSummary = linkifyHtml(fixedSummary, { target: '_blank' });
        }
        catch (error) {
            return origFixedSummary;
        }
        return fixedSummary || origFixedSummary;
    };
    var expandedEventsProps = {
        title: titleToDisplay,
        copyLink: copyLink,
        startDate: startDate,
        endDate: endDate,
        location: location,
        locationLink: locationLink,
        summary: convertToLinkifyHtml(summary),
        recurrence: recurrence,
        attachments: attachments,
        isDetailsVisible: isDetailsVisible && !isPrivate,
        eventColor: eventColor,
        type: type,
        originType: originType,
        timeFormat: timeFormat,
        onCopyClick: onCopyClick,
        onLocationClick: onLocationClick,
        onAttachmentClick: onAttachmentClick,
        // recurringEventId,
        weekStarter: weekStarter,
        groupByStartDate: groupByStartDate,
        experiments: experiments,
        calendarId: calendarId,
    };
    var hoverHandler = function (eventId) {
        //@ts-ignore
        onHover && onHover({ eventId: eventId });
    };
    var popper = (React.createElement(Popper, { placement: popperPlacement, title: expandedTitle, handleCloseClick: closeExpanded, handleClickAway: closeExpanded, open: Boolean(expanded), anchorEl: expanded, popperStyle: popperStyle, calendarPopoverClass: "Event", isMobile: isMobile, modifiers: popperModifiers, childrenDependencies: { recurrence: recurrence }, isCloseFocused: isEventEntered },
        React.createElement(WeeklyExpandedEvent, { title: title, expandedEventsProps: __assign({}, expandedEventsProps), isMobile: false, locale: locale })));
    var isOriginAllDay = originType === EventTypes.AllDayMultiDay;
    var isLastAllDayFiller = (isMobile || isAgenda) && isFiller && isOriginAllDay && isLastEventDate;
    var event = function (onEventClick, eventPopper) { return (React.createElement(React.Fragment, null,
        React.createElement("div", { "aria-roledescription": "event", role: "application", ref: eventRef, className: st(classes.root, {
                isTimeShown: isTimeShown,
                isNextWeekFirstFiller: isNextWeekFirstFiller,
                isLastFiller: isLastFiller || isLastEventDate,
                isMultiDay: isMultiDay,
                isAllDay: isAllDay,
                isFiller: isFiller,
                isInPopper: isInPopper,
                isEmpty: type === EventTypes.Null,
                isDefault: type === EventTypes.Default,
                isMobile: isMobile,
                isMonthlyMobile: isMobile && !isAgenda,
                isCut: isCut,
                isHover: isHover,
                isWeekend: isWeekend,
                isLastAllDayFiller: isLastAllDayFiller,
                isOriginAllDay: isOriginAllDay,
                isAgenda: isAgenda,
            }, className), style: inlineStyle, onClick: function (e) {
                if (type === EventTypes.AllDayMultiDay) {
                    if (e.detail === 0) {
                        onEventClick(e, true);
                    }
                    else {
                        onEventClick(e);
                    }
                }
            }, onMouseEnter: function () { return hoverHandler(isFiller ? originEventId : id); }, onMouseLeave: function () { return hoverHandler(''); } },
            React.createElement(TPAEvent, { className: classes.TPAevent, 
                //@ts-ignore
                title: eventTitle, 
                //@ts-ignore
                time: eventTime, showTime: isTimeShown, onClick: function () { }, selected: Boolean(expanded), "aria-has-popup": true, "aria-expanded": expanded ? true : false }),
            React.createElement(ReactResizeDetector, { onResize: setWidthState })),
        eventPopper)); };
    var options = { isLastFiller: isLastFiller, isNextWeekFirstFiller: isNextWeekFirstFiller };
    return eventContainers[type]({
        event: event,
        options: options,
        handleEventClick: handleEventClick,
        popper: popper,
        isInPopper: isInPopper,
        isMobile: isMobile,
        isAgenda: isAgenda,
        isCut: isCut,
        isWeekend: isWeekend,
        daysTillWeekend: daysTillWeekend,
        isToday: utils.isToday(cellDate),
        closeExpanded: closeExpanded,
    });
};
export default React.memo(Event, utils.areEqualProps);
//# sourceMappingURL=Event.js.map